var _path, _path2, _path3, _circle, _circle2, _path4, _rect, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLcrThrshold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79797 18.1281H18.5812V20.3941H6.79797V18.1281Z",
    fill: "#80D261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.443373 52.798L4.97539 57.5566C5.51925 58.1277 7.16586 57.7946 7.92119 57.5566L21.9704 43.734L23.7833 39.6552L18.3448 34.2167L14.7192 35.3497L13.133 36.7093L1.12318 49.399C-0.508351 51.0305 -0.00982912 52.3448 0.443373 52.798Z",
    fill: "#017297"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6108 32.1773L18.5714 34.4433L23.5566 39.8818L26.2758 37.6158C27.3635 36.8906 29.4483 37.3136 30.3547 37.6158C26.729 34.5944 19.7044 28.8236 20.6108 29.9113C21.5172 30.999 20.9885 31.8752 20.6108 32.1773Z",
    fill: "#D4F2F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.0592,
    cy: 19.9409,
    r: 19.9409,
    fill: "#D4F2F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2956,
    cy: 20.1675,
    r: 14.7291,
    fill: "#6BD9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0246 20.1675C53.0246 28.3021 46.4302 34.8965 38.2956 34.8965C48.9241 30.3645 51.2118 22.4335 48.4927 14.7291C43.7339 5.43842 33.7637 5.43842 38.2956 5.43842C46.4302 5.43842 53.0246 12.0328 53.0246 20.1675Z",
    fill: "#02C7DD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.4839,
    y: 36.2561,
    width: 6.34483,
    height: 2.26601,
    rx: 1.133,
    transform: "rotate(45.7042 17.4839 36.2561)",
    fill: "#025F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8273 14.9557C36.8273 13.9545 37.6389 13.1429 38.6401 13.1429H44.5723C45.5734 13.1429 46.3851 13.9545 46.3851 14.9557V18.8079H52.5715V21.5271H45.4787C44.4775 21.5271 43.6658 20.7155 43.6658 19.7143V15.8621H39.5465V24.9261C39.5465 25.9273 38.7349 26.7389 37.7337 26.7389H31.5657C30.5645 26.7389 29.7529 25.9273 29.7529 24.9261V20.1675H23.5665V17.4483H30.6593C31.6605 17.4483 32.4721 18.2599 32.4721 19.2611V24.0197H36.8273V14.9557Z",
    fill: "#80D261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcrThrshold);
export default __webpack_public_path__ + "static/media/LCRThrshold.17a7f400a91a0eb40bb7fef6fd0695e5.svg";
export { ForwardRef as ReactComponent };